// import react packages
import React, { useState } from "react";
import { useMutation } from "react-apollo";

// Import Polaris Components
import { Button, Modal } from "@shopify/polaris";

// import helpers
import constant from "lib/constant/constant";
import { baseHelper, errorHelper } from "lib/helpers";

// import gql
import { DISCONNECT_SHOP } from "app/product/apollo/mutations";

// import props
import { connectedShopProp } from "app/product/modules/generic/propTypes";
import { Link } from "react-router-dom";

const ConnectedShop = (props) => {
  const { currentUserData, setBanner, setIsConnected, setShop, cms, setDisconnectStatus} = props;
  const { DISCONNECT_SHOP: DISCONNECT } = constant.gql;

  const [isDisconnectActive, setIsDisconnectActive] = useState(false);

  // Vendors under this seller cannot disconnect their own shop — it has to go
  // through seller support. Matches on introductorySeller (a vendor) as well as
  // _id (the seller themselves), the same idiom used for isOblist/isMaison.
  const isDisconnectRestricted =
    !!currentUserData && [currentUserData.introductorySeller, currentUserData._id].includes("68113653effa140019f2e719");
  const disconnectRestrictedLabel =
    "Store disconnection requests must be processed by <b>XHAWI Seller Support.</b> <br />" +
    ' Please contact us at <a href="mailto:seller_support@xhawi.com">seller_support@xhawi.com</a>' +
    " and our team will assist you with your request.";

  const [disconnectShop, { loading: disconnectLoading }] = useMutation(DISCONNECT_SHOP);

  const disconnectShopConfirm = async () => {
    try {
      const response = await disconnectShop({
        variables: { input: { id: currentUserData.id } },
      });
      const responseError = baseHelper.getResponseError(response.data, DISCONNECT);
      if (responseError) {
        setBanner({ isOpen: true, status: constant.CRITICAL, title: responseError });
        return;
      }
      setBanner({ isOpen: true, status: constant.SUCCESS, title: cms("section.connect.message.success.disconnected") });
      setIsConnected(false);
      setShop("");
      setDisconnectStatus(true);
    } catch (exception) {
      setBanner({ isOpen: true, status: constant.CRITICAL, title: errorHelper.parse(exception) });
    }
  };

  const handleDisconnectModal = () => {
    setIsDisconnectActive(!isDisconnectActive);
  };

  return (
    <>
      <Modal
        open={isDisconnectActive}
        onClose={handleDisconnectModal}
        title={cms("section.connect.label.disconnectShop")}
        primaryAction={{
          content: `${cms("section.connect.label.disconnectShop")} ${currentUserData.shop}`,
          onAction: disconnectShopConfirm,
          destructive: true,
          loading: disconnectLoading,
          disabled: isDisconnectRestricted,
        }}
        secondaryActions={[
          {
            content: cms("section.connect.button.cancel"),
            onAction: handleDisconnectModal,
          },
        ]}
      >
        <Modal.Section>
          {isDisconnectRestricted ? (
            // eslint-disable-next-line react/no-danger
            <div dangerouslySetInnerHTML={{ __html: disconnectRestrictedLabel }} />
          ) : (
            `${cms("section.connect.label.disconnectWoocommerceShop")} ?`
          )}
        </Modal.Section>
      </Modal>
      <Link className="redColor" id="disconnect" onClick={handleDisconnectModal}>
        {cms("section.connect.label.disconnectShop")}
      </Link>
    </>
  );
};

ConnectedShop.propTypes = connectedShopProp;

export default ConnectedShop;
